import { AttributeTypes } from '../../Shop/components/Attributes/AttributeValue';
import { MediaResponse } from '../Media/contracts';
import { StorageStandResponse } from '../Storage/contracts';
import { Pagination } from '../contracts';

export enum ProductType {
  SIMPLE = 'simple',
  VARIABLE = 'variable'
}
export enum ProductStatus {
  AVAILABLE = 'available',
  RENTED = 'rented',
  RESERVED = 'reserved',
  DAMAGED = 'damaged',
  LOST = 'lost',
  PENDING = 'pending'
}

export interface StoreChildProductPayload {
  readonly name: string;
  readonly sku: string;
  readonly price: number;
  readonly points: number;
  readonly attribute_values: number[];
}

export interface StoreProductPayload extends StoreChildProductPayload {
  readonly type: ProductType;
  readonly category?: number;
  readonly storage_room_stand_id?: number;
  readonly addons: number[];
  readonly feature_values: number[];
  readonly variations?: StoreChildProductPayload[];
  readonly penalty_price: number;
  readonly short_description: string;
  readonly cover_image_id?: number | null;
  readonly gallery_media_ids?: number[];
}
export interface ProductResponse {
  readonly id: number;
  readonly type: ProductType;
  readonly category?: any;
  readonly name: string;
  readonly sku: string;
  readonly price: number;
  readonly points: number;
  readonly cover_image?: MediaResponse | null;
  readonly gallery?: MediaResponse[];
  readonly attribute_values?: ProductAttribute[];
  readonly feature_values?: ProductFeature[];
  readonly addons?: number[];
  readonly variations?: ProductResponse[];
  readonly storage_room_stand?: StorageStandResponse;
  readonly penalty_price: number;
  readonly short_description: string;
  readonly status: ProductStatus;
  readonly in_stock: number;
  readonly category_id: number;
  readonly storage_room_stand_id: number;
  readonly group_id: number;
  readonly cover_image_id?: number;
  readonly created_at: string;
  readonly updated_at: string;
  readonly pivot?: {
    quantity: number;
    price: number;
  };
}

export interface ProductAttribute {
  readonly id: number;
  readonly name: string;
  readonly value: string;

  readonly type: AttributeTypes;
  readonly attribute_id: number;
  readonly settings: { [key: string]: any };
}

export interface ProductFeature {
  readonly id: number;
  readonly name: string;
  readonly value: string;
  readonly feature_id: number;
  readonly settings: { [key: string]: any };
}

export interface ProductsWithPagination {
  pagination: Pagination;
  products: ProductResponse[];
}

export const ProductStatusLabels: { [key: string]: string } = {
  [ProductStatus.AVAILABLE]: 'Dostupno',
  [ProductStatus.RENTED]: 'Izdato',
  [ProductStatus.RESERVED]: 'Rezervisano',
  [ProductStatus.DAMAGED]: 'Oštećeno',
  [ProductStatus.LOST]: 'Izgubljeno',
  [ProductStatus.PENDING]: 'Čeka na odobrenje'
};
